import * as React from 'react';

export const DevelopmentPlanTab = () => {
  return <div>TBA tab content: DevelopmentPlanTab</div>;
};
